<span [class]="'bdg ' + color">
  {{ content }}
</span>
